import $ from 'jquery';
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';

const initOffcanvasToggling = () => {
  const $offcanvasTogglerButton = $('[data-offcanvas-toggler]');
  const $mainNav = $('#nav-header');

  $offcanvasTogglerButton.on('click', function () {
    const offcanvasSelector = $(this).attr('data-target');
    const $offcanvasElement = $(offcanvasSelector);
    $offcanvasElement.toggleClass('offcanvas--show');

    const isHidden = !$offcanvasElement.hasClass('offcanvas--show');
    $offcanvasElement.attr('aria-hidden', isHidden);
    $(this).attr('aria-expanded', !isHidden);

    const offcanvas = document.querySelector(offcanvasSelector).querySelector('.offcanvas__wrapper');

    isHidden ? enableBodyScroll(offcanvas) : disableBodyScroll(offcanvas);

    $mainNav.toggleClass('navbar--offcanvas');

    // Close offcanvas when clicking outside offcanvas-inner
    $(document).on('click', function(event) {
      if (!isHidden) {
        const $target = $(event.target);
        if (!$target.closest('.offcanvas__inner').length && !$target.closest('[data-offcanvas-toggler]').length) {
          $offcanvasElement.removeClass('offcanvas--show');
          $offcanvasElement.attr('aria-hidden', true);
          $offcanvasTogglerButton.attr('aria-expanded', false);
          enableBodyScroll(offcanvas);
          $mainNav.removeClass('navbar--offcanvas');
        }
      }
    });
  });

  $('.offcanvas__inner').on('click', function(event) {
    event.stopPropagation();
  });
};

export { initOffcanvasToggling };
